import { map } from "lodash";
import { MenuItemOption } from "./menu-item-option";
export class MenuItemOptionGroup {
    constructor(id, name, description, minSelections, maxSelections, sortOrder, options) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.minSelections = minSelections;
        this.maxSelections = maxSelections;
        this.sortOrder = sortOrder;
        this.options = options;
    }
    static fromDynamic(data) {
        const itemOptions = map(data["menu_item_options"], MenuItemOption.fromDynamic);
        // sort based on sort_order
        itemOptions.sort((a, b) => a.sortOrder - b.sortOrder);
        return new MenuItemOptionGroup(data["id"], data["name"], null, data["min_selections"], data["max_selections"], data["sort_order"], itemOptions);
    }
}
//# sourceMappingURL=menu-item-option-group.js.map